export const STATUSES = ['Draft', 'Sent', 'Client Reviewing', 'Accepted', 'Declined'];

export const STATUS_STYLES = {
  'Draft': { bg: '#F4F4F5', fg: '#031333' },
  'Sent': { bg: '#EFF6FF', fg: '#1B4A76' },
  'Client Reviewing': { bg: '#FFFBEB', fg: '#D97706' },
  'Accepted': { bg: '#F0FDF4', fg: '#16A34A' },
  'Declined': { bg: '#FEF2F2', fg: '#E5441A' },
};

export const PROJECT_TYPES = ['New Building', 'Alteration (Alt-1)', 'Alteration (Alt-2)', 'Alteration (Alt-3)', 'Change of Use', 'DOT Permit', 'FDNY Compliance', 'Violation Resolution', 'Other'];
export const BOROUGHS = ['Manhattan', 'Bronx', 'Brooklyn', 'Queens', 'Staten Island'];

export const CATEGORY_FILTERS = {
  'DOB Work': ['New Building', 'Alteration (Alt-1)', 'Alteration (Alt-2)', 'Alteration (Alt-3)', 'Change of Use'],
  'FDNY': ['FDNY Compliance'],
  'DOT': ['DOT Permit'],
  'Violation Resolution': ['Violation Resolution'],
  'Change of Use': ['Change of Use'],
};

export const STATE_OPTIONS = [['included', 'Included'], ['conditional', 'Conditional'], ['excluded', 'Excluded']];

export const PAYMENT_STYLES = {
  unpaid: { bg: '#F4F4F5', fg: '#031333', label: 'Unpaid' },
  invoiced: { bg: '#FFFBEB', fg: '#D97706', label: 'Invoiced' },
  paid: { bg: '#F0FDF4', fg: '#16A34A', label: 'Paid' },
};

export const CAT_ORDER = ['DOB', 'FDNY', 'DOT', 'General'];

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export function itemState(it) {
  const s = it.item_state;
  if (s === 'included' || s === 'conditional' || s === 'excluded') return s;
  return it.included === false ? 'excluded' : 'included';
}

export function StatusPill({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.Draft;
  return <span style={{ backgroundColor: s.bg, color: s.fg, borderRadius: '2px', fontSize: '12px', padding: '2px 8px', fontFamily: "'DM Sans', sans-serif" }}>{status}</span>;
}
